<template>
  <div class="gray-bcg">
    <img
      src="../assets/image/blueShape.png"
      alt="blueShape"
      class="blueShape"
      width="20%"
    />
    <img
      src="../assets/image/greenShape.png"
      alt="greenShape"
      width="30%"
      class="greenShape"
    />
    <myheader />

    <div class="container relative vh60">
      <div class="row mx-10 my-10">
        <!-- <div class="col-12 col-lg-6">
          <div class="row b1 h1">{{ $t("contact-us") }}</div>
          <div class="row b1 h5 gray-text">{{ $t("sendToUs") }}</div>
          <div class="row">
            <div class="col-6">
              <v-text-field filled :label="$t('name')"></v-text-field>
            </div>
            <div class="col-6">
              <v-text-field filled :label="$t('email')"></v-text-field>
            </div>
            <div class="col-12 mt-n10">
              <v-textarea filled :label="$t('yourEmail')"></v-textarea>
            </div>
            <div class="col-12 mt-n10">
              <v-btn class="blue-bcg text-light mr-3 rounded-pill">
                {{ $t("sendEmail") }}
                <v-icon class="text-light m-1">mdi-send</v-icon>
              </v-btn>
            </div>
          </div>
        </div> -->
        <div class="col-12 col-lg-6">
          <div class="row b1 h1">{{ $t("conection-info") }}</div>
          <div class="row">
            <div class="col-4 h5 b1">
              <v-icon>mdi-web</v-icon> {{ $t("virtual") }}
            </div>
            <div class="col-8">
              <v-icon class="p-1">mdi-twitter</v-icon>
              <v-icon class="p-1">mdi-youtube</v-icon>
              <v-icon class="p-1">mdi-instagram</v-icon>
              <v-icon class="p-1">mdi-send</v-icon>
            </div>
          </div>
          <div class="row">
            <div class="col-4 h5 b1">
              <v-icon>mdi-at</v-icon>{{ $t("email") }}
            </div>
            <div class="col-8 b1 h5 gray-text">support@copypeyk.com</div>
          </div>
          <div class="row">
            <div class="col-4 h5 b1">
              <v-icon>mdi-phone</v-icon>{{ $t("phone") }}
            </div>
            <div class="col-8 b1 h5 gray-text">{{ $t("contact-phone") }}</div>
          </div>
          <div class="row">
            <div class="col-4 h5 b1">
              <v-icon>mdi-map-marker</v-icon>{{ $t("address") }}
            </div>
            <div class="col-8"></div>
          </div>
        </div>
      </div>
    </div>

    <myfooter class="relative" />
  </div>
</template>
<script>
import myheader from "../components/Share/Header.vue";
import myfooter from "../components/Share/Footer.vue";

export default {
  name: "ContactUs",
  components: {
    myheader,
    myfooter,
  },
};
</script>
<style scoped>
.blueShape {
  position: absolute;
  top: 15%;
  right: -10%;
}
.greenShape {
  position: absolute;
  top: 30%;
  right: 90%;
}
</style>
